import { IFormErrors } from '@interfaces/IFormsErrors';
import { INote } from '@interfaces/INoteData';
import { IWorkDebtors } from '@interfaces/IWorkDebtors';

export interface IWorkDebtorsState {
  data: IWorkDebtors | null;
  success: boolean;
  isLoading: boolean;
  isLoadingChanges: boolean;
  errors: IFormErrors | null;
  workDebtorsNotes: {
    data: INote[];
    isLoading: boolean;
    errors: IFormErrors | null;
  };
}

export const initialsWorkDebtorsState: IWorkDebtorsState = {
  data: null,
  success: false,
  isLoading: false,
  isLoadingChanges: false,
  errors: null,
  workDebtorsNotes: {
    data: [],
    isLoading: false,
    errors: null,
  },
};
